(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-product-triptych"] && !Shopify.designMode) return;
  try {
    
  class BMProductTriptych {
    constructor(section) {
      section.querySelectorAll('.bm-product-form').forEach(form => this.initForm(form));
    }

    initForm(form) {
      const radios = form.querySelectorAll('.bm-size-radio');
      const variantInput = form.querySelector('.bm-variant-id');
      const submitBtn = form.querySelector('.bm-add-btn');
      const sizeSelector = form.querySelector('.bm-size-selector');
      const productHandle = sizeSelector?.dataset.productHandle;

      if (!variantInput || !submitBtn) return;

      if (radios.length && productHandle) {
        fetch(`/products/${productHandle}.js`)
          .then(r => r.json())
          .then(data => {
            const variants = data.variants;
            const optionIndex = parseInt(sizeSelector.dataset.optionIndex || '0', 10);

            const updateVariant = () => {
              const checked = form.querySelector('.bm-size-radio:checked');
              if (!checked) return;
              const match = variants.find(v => v.options[optionIndex] === checked.value);
              if (match) {
                variantInput.value = match.id;
                submitBtn.disabled = !match.available;
                submitBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
              }
            };

            radios.forEach(r => r.addEventListener('change', updateVariant));
            updateVariant();
          })
          .catch(() => {});
      }

      form.addEventListener('submit', e => {
        e.preventDefault();
        if (submitBtn.disabled) return;

        const variantId = variantInput.value;
        if (!variantId) return;

        submitBtn.disabled = true;
        submitBtn.textContent = '...';

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer ? cartDrawer.getSectionsToRender().map(s => s.id) : [];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1,
            sections: sections,
            sections_url: window.location.pathname
          })
        })
        .then(r => r.json())
        .then(response => {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Added!';
          setTimeout(() => { submitBtn.textContent = 'Add to bag'; }, 2000);
          if (cartDrawer) {
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents(response);
            else if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        })
        .catch(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Try again';
          setTimeout(() => { submitBtn.textContent = 'Add to bag'; }, 2000);
        });
      });
    }
  }

  document.querySelectorAll('.bm-triptych').forEach(el => new BMProductTriptych(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
